/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useState} from 'react';
import {Button, Table, TableColumnsType} from "antd";
import dayjs from "dayjs";
import {useStore} from "zustand";
import styles from './BaechaGroupDone.module.scss';
import PageTitle from "../../components/common/PageTitle/PageTitle";
import {GroupSearchSelect, GroupValue} from "../../components/common/selector/GroupSearchSelect";
import apiClient from "../../api/apiClient";
import {formatCurrency} from "../../util/format";
import {formatKorDate} from "../../util/date";
import {useMessageStore} from "../../stores/messageStore";
import {Baecha} from "../../types/Baecha";

const emptySearchGroup: GroupValue = {
	key: '',
	label: '',
	value: '',
	name: '',
	configs: {},
}

const BaechaGroupDone = () => {
	const { setMessages } = useStore(useMessageStore);
	const [selectedGroup, setSelectedGroup] = useState<GroupValue>(emptySearchGroup);
	const [data, setData] = useState<Baecha[]>([]);

	const onClickGroupName = async (value: GroupValue) => {
		if (!value?.key) return;

		setSelectedGroup(value);
		const path = `/api/admin/business/baecha/${value.key}`;
		const res = await apiClient.get(path);
		setData(res.data);
	};

	const onClickDone = async (record: Baecha) => {
		// 작업완료 처리
		try {
			await apiClient.post(`/api/admin/business/baecha/done`, {
				baechaId: record.id,
				groupId: record.baljuGroupId,
			});

			// 목록 다시 가져오기
			const res = await apiClient.get(`/api/admin/business/baecha/${selectedGroup.key}`);
			setData(res.data);
			setMessages('success', `작업 완료 성공: 배차번호 ${record.baechaNo}`);
		} catch (e) {
			setMessages('error', `작업 완료 실패: 배차번호 ${record.baechaNo}`);
		}
	};

	const getBaechaTypeStr = (text: string) => {
		if (text === 'rollcall') return '점호';
		if (text === 'normal') return '일반';
		if (text === 'urgent') return '긴급';
		if (text === 'designated') return '지명';
		return '';
	};

	const columns: TableColumnsType<Baecha> = [
		{
			title: '번호',
			dataIndex: 'baechaNo',
			key: 'baechaNo',
			width: 70,
			align: 'center',
			ellipsis: true,
		},
		{
			title: '발주시간',
			dataIndex: 'baljuingStartDate',
			width: 110,
			align: 'center',
			ellipsis: true,
			render: (text: string) => (
				<div>
					<div style={{ textAlign: 'right' }}>
						{formatKorDate(text)}
					</div>
					<div style={{ textAlign: 'right' }}>
						{dayjs(text).format('HH:mm')}
					</div>
				</div>
			)
		},
		{
			title: (
				<>
					<div>발주자</div>
				</>
			),
			dataIndex: 'baljuMemberNickname',
			key: 'baljuMemberNickname',
			width: 150,
			align: 'center',
			ellipsis: true,
		},
		{
			title: (
				<>
					<div>수주자</div>
				</>
			),
			dataIndex: 'sujuMemberNickname',
			key: 'sujuMemberNickname',
			width: 150,
			align: 'center',
			ellipsis: true,
		},
		{
			title: '유형',
			dataIndex: 'baechaType',
			key: 'baechaType',
			width: 70,
			align: 'center',
			ellipsis: true,
			render: (text: string) => <div>{getBaechaTypeStr(text)}</div>
		},
		{
			title: '차량',
			dataIndex: 'carType',
			key: 'carType',
			width: 70,
			align: 'center',
			ellipsis: true,
		},
		{
			title: '작업일',
			dataIndex: 'workDay',
			key: 'workDay',
			width: 70,
			align: 'center',
			ellipsis: true,
		},
		{
			title: '작업시간',
			dataIndex: 'workHour',
			key: 'workHour',
			width: 70,
			align: 'center',
			ellipsis: true,
		},
		{
			title: '금액',
			dataIndex: 'price',
			key: 'price',
			width: 110,
			align: 'center',
			ellipsis: true,
			render: (text: string) => (<div style={{ textAlign: 'right' }}><span>{formatCurrency(Number(text), 'KRW')}</span></div>)
		},
		{
			title: '장소',
			dataIndex: 'workLoc',
			key: 'workLoc',
			width: 200,
			align: 'center',
			ellipsis: true,
		},
		{
			title: <div style={{ textAlign: 'center' }}>작업내용</div>,
			dataIndex: 'workContent',
			key: 'workContent',
			width: 200,
			align: 'left',
			ellipsis: true,
		},
		{
			title: <div style={{ textAlign: 'center' }}>특이사항</div>,
			dataIndex: 'workEtc',
			key: 'workEtc',
			align: 'left',
			ellipsis: true,
		},
		{
			title: '작업완료',
			dataIndex: '',
			key: '',
			width: 110,
			align: 'center',
			ellipsis: true,
			render: (value: any, record: Baecha, index: number) => (
				<Button
					className={styles.adjustBtn}
					onClick={() => onClickDone(record)}
				>
					완료 처리
				</Button>
			),
		},
	];

	return (
		<div className={styles.wrap}>
			<PageTitle title="미완료 작업"/>

			<div style={{ width: 250 }}>
				<GroupSearchSelect
					selectedGroup={selectedGroup}
					onChange={onClickGroupName}
					placeholder="그룹 검색"
				/>
			</div>

			<div style={{ height: 20 }} />

			<Table
				className={styles.tableWrap}
				size="small"
				tableLayout="fixed"
				bordered
				columns={columns}
				dataSource={data.map(row => ({ ...row, key: row.baechaNo }))}
				pagination={false}
			/>
		</div>
	);
};

export default BaechaGroupDone;
